"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumPaymentReceivablesParams = exports.SourgumPaymentReceivablesQuery = exports.PaymentCreateTransport = exports.PaymentTransport = exports.SearchPaymentsQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const customer_1 = require("../customer");
const payment_processing_1 = require("./payment-processing");
exports.SearchPaymentsQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    paymentSentAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentSentBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    paymentIdentifer: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentProcessor: typebox_1.Type.Optional(payment_processing_1.SupportedPaymentProcessorTransport),
    paymentProcessorChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripePayoutID: typebox_1.Type.Optional(typebox_1.Type.String()),
    rainforestPayinID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.PaymentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    paymentSentDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentReceivedDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    amount: typebox_1.Type.Number(),
    paymentMethod: common_1.PaymentMethod,
    enteredByUserID: typebox_1.Type.String(),
    paymentIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentProcessor: typebox_1.Type.Optional(payment_processing_1.SupportedPaymentProcessorTransport),
    paymentProcessorChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceParentID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripePayoutID: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.PaymentCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.PaymentTransport, ['id', 'date', 'amount', 'enteredByUserID']),
    typebox_1.Type.Object({
        date: typebox_1.Type.Optional(typebox_1.Type.String()),
        amount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        haulerVendorID: typebox_1.Type.Optional(typebox_1.Type.String()),
        revenueShare: typebox_1.Type.Optional(typebox_1.Type.Number()),
        revenueShareAmount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        contactsToNotify: typebox_1.Type.Optional(typebox_1.Type.Array(customer_1.BaseCustomerContact)),
        /** When true, sets paidInFull=true directly without balance calculation. Used for online checkout
         * where the payment amount is known to match the invoice total (avoiding rounding discrepancies). */
        markFullyPaid: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.SourgumPaymentReceivablesQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    dateAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentSentAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentSentBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    paymentIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentProcessor: typebox_1.Type.Optional(payment_processing_1.SupportedPaymentProcessorTransport),
    paymentProcessorChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.SourgumPaymentReceivablesParams = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
});
//# sourceMappingURL=payment-transport.js.map